import React, { useState } from "react";
import * as Types from "../types/BaseTypes";
import Disclaimer from "../objects/Disclaimer";

import HC from "../images/icon-hc";
import OA from "../images/icon-oa";

export default (props: {
  core: Types.Core;
  setCore: Function;
  next: Function;
  prev: Function;
}) => {
  const { core, setCore, next, prev } = props;

  return (
    <React.Fragment>
      <div className={"page home"} style={{ display: "flex", flexFlow: "row" }}>
        <div
          className={"details-panel"}
          style={{ ...props, display: "flex", flexFlow: "column" }}
          onClick={() => {
            setCore({ ...core, application: Types.Application.HumanComfort });
            next();
          }}
        >
          <HC />
          <p>Human Comfort</p>
        </div>
        <div
          className={"details-panel"}
          style={{ ...props, display: "flex", flexFlow: "column" }}
          onClick={() => {
            setCore({
              ...core,
              application: Types.Application.OtherApplications,
            });
            next();
          }}
        >
          <OA style={{ marginLeft: -20 }} />
          <p>
            Other Applications
            <br />
            Above Ground
          </p>
        </div>
      </div>
      <div
        style={{
          maxWidth: 700,
          margin: "30px auto",
          padding: "0 30px",
          fontSize: 10,
          color: "#B3B3B3",
          fontWeight: "bold",
        }}
      >
        DISCLAIMER
        <br />
        {Disclaimer}
      </div>
    </React.Fragment>
  );
};
